
<template>
  <div>
    <div class="searchBox" ref="searchBox">
      <el-form  :inline="true"  :model="searchFrom" ref="searchFrom" class="demo-form-inline"  label-width="100px"  size="mini"  >
        <div class="inpBox box">
            <el-form-item label="捆包号" class="item1">
              <el-input placeholder="" type="textarea" v-model="searchFrom.cargoBarcode" class="gjh"></el-input>
            </el-form-item>
           <template v-for="column in tabHeadList" >
            <template v-if="column.isSettingQuery==1" >
              <el-form-item label="货物类型:" v-if="column.enName=='productTypeName'" :key="column.enName">
                <el-select  v-model="searchFrom.productType" filterable placeholder="请选择">
                  <el-option  label="全部" value="" ></el-option>
                  <el-option v-for="item in HWlist" :label="item.showName" :value="item.itemNo" :key="item.id"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="是否一票制:"  v-else-if="column.enName=='ticketSystemYn'" :key="column.enName">
                <el-select  v-model="searchFrom.ticketSystemYn" filterable placeholder="请选择" >
                  <el-option  label="全部" value="" ></el-option>
                  <el-option  label="是" value="是" ></el-option>
                  <el-option  label="否" value="否" ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="收入计价:"  v-else-if="column.enName=='revenueValuationName'" :key="column.enName">
                <el-select v-model="searchFrom.revenueValuation" placeholder="请选择">
                  <el-option  label="全部" value="" ></el-option>
                  <el-option v-for="item in SRJJlist"  :label="item.showName" :value="item.itemNo" :key="item.id"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="状态:"  v-else-if="column.enName=='orderStateName'" :key="column.enName">
                <el-select v-model="searchFrom.orderStates" placeholder="请选择">
                  <el-option  label="全部" value="" ></el-option>
                  <el-option  label="待处理+处理中" value="0,1" ></el-option>
                  <el-option  label="待处理" value="0" ></el-option>
                  <el-option  label="处理中" value="1" ></el-option>
                  <el-option  label="已处理" value="2" ></el-option>
                  <el-option  label="已作废" value="3" ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="要求到达时间:" class="item2"  v-else-if="column.enName=='arrivalTime'" :key="column.enName">
                <el-date-picker
                    v-model="searchFrom.arrivalTimes"
                    format="yyyy-MM-dd HH:mm:ss"
                    value-format="yyyy-MM-dd HH:mm:ss"
                    type="datetimerange"
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                ></el-date-picker>
              </el-form-item>
              <el-form-item label="创建时间:" class="item2"  v-else-if="column.enName=='createTime'" :key="column.enName">
                <el-date-picker
                    v-model="searchFrom.createTimes"
                    format="yyyy-MM-dd HH:mm:ss"
                    value-format="yyyy-MM-dd HH:mm:ss"
                    type="datetimerange"
                    range-separator="至"
                    start-placeholder="开始时间"
                    end-placeholder="结束时间"
                ></el-date-picker>
              </el-form-item>
              <el-form-item :label="column.cnName+':'" v-else :key="column.enName">
                <el-input placeholder="" v-model="searchFrom[column.enName]" ></el-input>
              </el-form-item>
            </template>
           </template>

        </div>
        <!-- <div v-if="isZhankai" class="inpBox box">
          <el-form-item label="订单编号:" >
            <el-input  placeholder="" v-model="searchFrom.orderNo"></el-input>
          </el-form-item>
          <el-form-item label="始发流向:" >
            <el-input  placeholder="" v-model="searchFrom.startDirection"></el-input>
          </el-form-item>
          <el-form-item label="目的流向:" >
              <el-input  placeholder="" v-model="searchFrom.endDirection"></el-input>
          </el-form-item>
          <el-form-item label="外部单号:" >
            <el-input  placeholder="" v-model="searchFrom.externalOrderNumber"></el-input>
          </el-form-item>
        </div> -->
        <!-- <div class="box1">
            <i class="el-icon-arrow-down icon" v-if="isZhankai" @click="isZhankai=!isZhankai"></i>
            <i class="el-icon-arrow-up icon" v-if="!isZhankai"  @click="isZhankai=!isZhankai"></i>
        </div> -->
        <div style="display: flex;justify-content: space-between;align-items: center;padding-right: 20px;">
          <div class="searchBtnBox">
            <el-button type="primary" v-if="btnFlg[0]" size="mini" @click="searchFn">查询</el-button>
            <el-button type="primary" v-if="btnFlg[1]" size="mini" @click="resetForm('searchFrom')">重置</el-button>
            <!-- <el-button type="primary" @click="THimportFn()">导入</el-button> -->
            <el-button type="primary" v-if="btnFlg[2]" size="mini" @click="exportFn" :disabled="isDisable">导出</el-button>
            <el-button type="primary" v-if="btnFlg[3]" size="mini" @click="dayinFN">打印</el-button>
            <el-button type="primary" v-if="btnFlg[4]" size="mini" @click="chaihedanFN(1)">合单</el-button>
            <el-button type="primary" v-if="btnFlg[5]" size="mini" @click="chaihedanFN(2)">拆单</el-button>
            <el-button type="primary" v-if="btnFlg[6]" size="mini" @click="zhipaiFN">指派</el-button>

          </div>
          <div @click="tabSetting"><i class="el-icon-s-tools"></i></div>
        </div>

      </el-form>
    </div>
    <!-- 表格 -->
    <div :style="{height:h}">
      <el-table  :data="tableList" ref="table" v-loading="loading" bordersize="mini" @selection-change="selectGoods" @row-click="handleRowClick"
      class="table" height="100%" style="width:100%" center border  row-key="orderId" lazy :load="load" :key="tableKey"
      :tree-props="{children: 'children', hasChildren: 'hasChildren'}" v-if="tabHeadList.length>0">
        <el-table-column type="selection" width="55"></el-table-column>
        <!-- <el-table-column  type="index" width="55" label="序号"></el-table-column> -->
        <el-table-column label="序号" width="55">
          <template slot-scope="scope">
            <span v-if="scope.row.num">{{scope.row.num}}</span>
            <span v-else>-</span>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="120">
          <template slot-scope="scope">
            <div>
             <el-button type="text" size="mini" v-if="scope.row.orderState!=3&&scope.row.orderState!==0"  v-show="btnFlg[7]" @click="wayFn(scope.row)">运单</el-button>
             <el-button type="text" size="mini"  v-show="btnFlg[8]" @click="fujianFn(scope.row)">附件</el-button>
            </div>
          </template>
        </el-table-column>
        <template v-for="column in tabHeadList">
          <template v-if="column.enName=='orderNo'">
            <el-table-column property="" :formatter="formatterRowEmpty" width="240" label="订单编号" :key="column.enName">
              <template slot-scope="scope">
                <span style="color: #0c46a2;cursor: pointer;" @click="detailFn(scope.row)">{{scope.row.orderNo}}</span>
              </template>
            </el-table-column>
          </template>
          <template v-else-if="column.enName=='residualTotalWeight'">
            <el-table-column property="orderSource" label="剩余量"  width="200" :key="column.enName">
              <template scope="scope">
                <div>
                  <div style="color: #0c46a2;cursor: pointer;" @click="WHSYLFn(scope.row)" v-if="scope.row.goodsYn==1">
                    <span>{{scope.row.residualTotalWeight}}</span>
                  </div>
                  <div v-else>
                    <span>{{scope.row.residualTotalWeight}}</span>
                  </div>
                </div>
              </template>
            </el-table-column>
          </template>
          <template v-else-if="column.enName=='orderStateName'">
            <el-table-column property="orderSource" label="状态"  width="120" :key="column.enName">
              <template scope="scope">
                <div>
                  <span  style="color: #D51212;" v-if="scope.row.orderState===0">{{scope.row.orderStateName}}</span>
                  <span  style="color: #E99D42;" v-else-if="scope.row.orderState==1">{{scope.row.orderStateName}}</span>
                  <span  style="color: #81B337;" v-else-if="scope.row.orderState==2">{{scope.row.orderStateName}}</span>
                  <span  style="color: #9A9A9A;" v-else-if="scope.row.orderState==3">{{scope.row.orderStateName}}</span>
                  <span v-else>{{scope.row.orderStateName}}</span>
                </div>
              </template>
            </el-table-column>
          </template>
          <template v-else-if="column.enName=='urgencyFlagName'">
            <el-table-column property="orderSource" label="提货紧急程度"  width="120" :key="column.enName">
              <template scope="scope">
                <div>
                  <span  style="color: #D51212;" v-if="scope.row.urgencyFlag===2">{{scope.row.urgencyFlagName}}</span>
                  <span  style="color: #E99D42;" v-else-if="scope.row.urgencyFlag==1">{{scope.row.urgencyFlagName}}</span>
                  <span  v-else>{{scope.row.urgencyFlagName}}</span>
                </div>
              </template>
            </el-table-column>
          </template>
          <template v-else>
            <el-table-column  :key="column.enName" :prop="column.enName" :label="column.cnName" :width="column.fieldWidth" show-overflow-tooltip :formatter="formatterRowEmpty">
              <el-table-column v-for="item in column.child" :key="item.enName" :prop="item.enName" :label="item.cnName" :width="item.fieldWidth" :formatter="formatterRowEmpty">
              </el-table-column>
            </el-table-column>
          </template>
        </template>

        <!-- <el-table-column property="" :formatter="formatterRowEmpty" width="240" label="订单编号">
          <template slot-scope="scope">
            <span style="color: #0c46a2;cursor: pointer;" @click="detailFn(scope.row)">{{scope.row.orderNo}}</span>
          </template>
        </el-table-column>
        <el-table-column label="状态" width="100">
          <template slot-scope="scope">
            <span>{{[ "待处理", "处理中", "已处理","已作废"][scope.row.orderState]}}</span>
          </template>
        </el-table-column>
        <el-table-column property="orderSource" label="订单来源">
          <template scope="scope">
            <div>
              <span >{{[ "手动", "转包", "货主端","分段"][scope.row.orderSource]}}</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column property="orderSource" label="配载方式">
          <template scope="scope">
            <div>
              <span>{{[ "指派", "转包","分段"][scope.row.stowageType]}}</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column property="payee" :formatter="formatterRowEmpty" width="200" label="结算客户"></el-table-column>
        <el-table-column property="productTypeName" :formatter="formatterRowEmpty" width="120" label="货物类型"></el-table-column>
        <el-table-column property="orderWeight" label="订单量" width="120">
          <template scope="scope">
            <div>
              <span v-if="scope.row.orderWeight&&scope.row.orderNumber">
                {{scope.row.orderWeight}}{{scope.row.measuringUnit}}/{{scope.row.orderNumber}}件</span>
              <span v-else>
                {{scope.row.orderWeight}}{{scope.row.measuringUnit}}</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column property="orderSource" label="配载量"  width="120">
          <template scope="scope">
            <div>
              <span v-if="scope.row.goodsYn==1">
                {{scope.row.stowageWeight}}{{scope.row.measuringUnit}}/{{scope.row.stowageNumber}}件</span>
              <span v-else>
                {{scope.row.stowageWeight}}{{scope.row.measuringUnit}}</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column property="orderSource" label="剩余量"  width="120">
          <template scope="scope">
            <div>
              <div style="color: #0c46a2;cursor: pointer;" @click="WHSYLFn(scope.row)" v-if="scope.row.goodsYn==1">
                <span>
                  {{scope.row.residualWeight}}{{scope.row.measuringUnit}}/{{scope.row.residualNumber}}件</span>
              </div>
              <div v-else>
                  <span>{{scope.row.residualWeight}}{{scope.row.measuringUnit}}</span>
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column property="startDirection" width="180" :formatter="formatterRowEmpty" label="始发流向"></el-table-column>
        <el-table-column property="endDirection" width="180" :formatter="formatterRowEmpty" label="目的流向"></el-table-column>
        <el-table-column width="170" property="arrivalTime" :formatter="dateTimeFormat" label="要求到货时间"></el-table-column>
        <el-table-column property="requiredModel" width="100" :formatter="formatterRowEmpty" label="需求车型"></el-table-column>
        <el-table-column property="needLength" width="100" :formatter="formatterRowEmpty" label="需求车长"></el-table-column>
        <el-table-column property="receiptRequest" width="100" :formatter="formatterRowEmpty" label="回单要求"></el-table-column>
        <el-table-column property="ticketSystemYn" width="100" :formatter="formatterRowEmpty" label="是否一票制"></el-table-column>
        <el-table-column property="makeTicketYn" width="100" :formatter="formatterRowEmpty" label="是否开票"></el-table-column>
        <el-table-column property="revenueValuation" label="收入计价">
          <template scope="scope">
            <div>
              <span>{{[ "按吨", "包车","按方","按件"][scope.row.revenueValuation]}}</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column property="incomePattern" label="收入方式">
          <template scope="scope">
            <div>
              <span>{{[ "月结", "现结"][scope.row.incomePattern]}}</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column property="incomeUnitPrice" label="收入单价" width="100">
          <template scope="scope">
            <div>
              {{scope.row.incomeUnitPrice}}元/{{scope.row.measuringUnit}}
            </div>
          </template>
        </el-table-column>
        <el-table-column property="incomeAmount" width="120" :formatter="formatterRowEmpty" label="收入金额(元)"></el-table-column>
        <el-table-column property="payer" width="150" :formatter="formatterRowEmpty" label="转包单位"></el-table-column>
        <el-table-column property="expenditurePattern" label="支出方式">
          <template scope="scope">
            <div>
              <span>{{[ "月结", "现结"][scope.row.expenditurePattern]}}</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column property="freightPricingType" label="运费计价">
          <template scope="scope">
            <div>
              <span>{{["按吨", "包车","按方","按件"][scope.row.freightPricingType]}}</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column property="freightUnitPrice" label="运费单价" width="120">
          <template scope="scope">
            <div>
              {{scope.row.freightUnitPrice}}元/{{scope.row.measuringUnit}}
            </div>
          </template>
        </el-table-column>
        <el-table-column property="freightAmount" width="120" :formatter="formatterRowEmpty" label="运费金额(元)"></el-table-column>
        <el-table-column property="serviceRate" width="100" :formatter="formatterRowEmpty" label="服务费率%"></el-table-column>
        <el-table-column property="serviceCharge" width="120" :formatter="formatterRowEmpty" label="服务费(元)"></el-table-column>
        <el-table-column property="freightTotal" width="120" :formatter="formatterRowEmpty" label="运费总额(元)"></el-table-column>
        <el-table-column property="taxRate" width="100" :formatter="formatterRowEmpty" label="税率%"></el-table-column>
        <el-table-column property="businessUnit" width="120" :formatter="formatterRowEmpty" label="业务部门"></el-table-column>
        <el-table-column property="businessUser" width="120" :formatter="formatterRowEmpty" label="业务人员"></el-table-column>
        <el-table-column property="orderBusinessType" label="业务类型">
          <template scope="scope">
            <div>
              <span >{{[ "外库业务", "本库业务"][scope.row.orderBusinessType]}}</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="发货信息" width="450">
          <template slot-scope="scope">
            <div class="box1">
              <span style="color:#0c46a2">(发){{scope.row.deliverCompany}}</span>
              <span>{{scope.row.deliverPerson}}</span>
            </div>
            <div class="box1">
              <span>{{scope.row.deliverPhone}}</span>
              <span>{{scope.row.deliverAddress}}</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="收货信息" width="450">
          <template slot-scope="scope">
            <div class="box1">
              <span style="color:#F56C6C">(收){{scope.row.receivingCompany}}</span>
              <span>{{scope.row.receivingPerson}}</span>
            </div>
            <div class="box1">
              <span>{{scope.row.receivingPhone}}</span>
              <span>{{scope.row.receivingAddress}}</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column property="externalOrderNumber" :formatter="formatterRowEmpty" width="180" label="外部单号" show-overflow-tooltip></el-table-column>
        <el-table-column property="createUser" width="150" :formatter="formatterRowEmpty" label="创建人"></el-table-column>
        <el-table-column property="createTime" width="170" :formatter="dateTimeFormat" label="创建时间"></el-table-column> -->
      </el-table>
    </div>
    <!-- 分页 -->
    <div>
      <el-pagination
        background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="searchFrom.pageNo"
        :page-sizes="[25,50,100]"
        :page-size="searchFrom.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      ></el-pagination>
    </div>
    <!-- 剩余货物信息 -->
    <el-dialog  title="剩余货物信息" :close-on-click-modal="false" :close-on-press-escape="false"  @close="SYHWflag = false"  :visible.sync="SYHWflag" width="1000px" center>
      <div id="printMe" class="dayinBox"  ref="printSY">
         <div class="box3">
            <p class="box31">订单号：{{rowData.orderNo}}</p>
            <p class="box31">结算客户：{{rowData.payee}}</p>
        </div>
        <div class="box3">
          <p class="box31" style="color:#67C23A">始发流向：{{rowData.startDirection}}</p>
          <p class="box31" style="color:#F56C6C">目的流向：{{rowData.endDirection}}</p>
          <p>货物：{{rowData.productTypeName}}/
            <span v-if="rowData.residualWeight"><span class="red">{{rowData.residualWeight}}</span>吨</span>
            <span v-if="rowData.residualWeight&&(rowData.residualNumber||rowData.residualVolumn)">/</span>
            <span v-if="rowData.residualNumber"><span class="red">{{rowData.residualNumber}}</span>件</span>
            <span v-if="rowData.residualNumber&&rowData.residualVolumn">/</span>
            <span v-if="rowData.residualVolumn"><span class="red">{{rowData.residualVolumn}}</span>方</span>
          </p>
          <!-- <el-button type="primary">打印</el-button> -->
        </div>
        <table style="word-break:break-all;word-wrap:break-all;" class="sytable" v-if="SYgoodList.length>0">
        <tr>
          <td>序号</td>
          <td>捆包号</td>
          <td>重量(吨)</td>
          <td>数量(件)</td>
          <td>体积(方)</td>
          <td>品名</td>
          <td>材质</td>
          <td>规格</td>
          <td>货位</td>
          <td>合同号</td>
          <td>合约号</td>

        </tr>
        <tr v-for="(item, index) in SYgoodList" :key="index">
          <td >{{ index+1 }}</td>
          <td >{{ item.cargoBarcode ?item.cargoBarcode :'-'}}</td>
          <td >{{ item.weight?Number(item.weight).toFixed(3):'-' }}</td>
          <td >{{ item.number?item.number:'-'}}</td>
          <td >{{ item.volumn?Number(item.volumn).toFixed(3):'-' }}</td>
          <td >{{ item.productName?item.productName:'-'  }}</td>
          <td >{{ item.model?item.model:'-' }}</td>
          <td >{{ item.specification ?item.specification:'-'}}</td>
          <td >{{item.cargoLocation?item.cargoLocation:'-'}}</td>
          <td >{{ item.contractNumber?item.contractNumber:'-' }}</td>
          <td >{{item.agreementNumber?item.agreementNumber:'-'}}</td>
        </tr>
      </table>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="SYHWflag = false">取 消</el-button>
        <el-button type="primary" @click="SYdayinFn">打印</el-button>
      </span>
    </el-dialog>
    <!-- 附件 -->
    <el-dialog  title="附件" :close-on-click-modal="false" :close-on-press-escape="false"   :visible.sync="fujianFlag" width="500px" center>
      <div class="fujianBox">
         <el-button type="text" v-for="item in fujianList" @click="fujianClick(item)" :key="item.id">{{item.name}}</el-button>
      </div>
      <el-dialog  title="查看图片" :close-on-click-modal="false" :close-on-press-escape="false"   :visible.sync="lookImgFlag"
        append-to-body width="800px" center>
        <div style="text-align: right;">
          <el-button type="primary" @click="dayinImgFn">打印</el-button>
          <div id="printMe"  ref="print">
            <el-image style="width: 100%;" :src="imgUrl" fit="contain"></el-image>
          </div>
        </div>
      </el-dialog>
    </el-dialog>
    <!-- 导入 -->
    <importC v-if="importDialog" @DRsave="DRsave" @destroy="destroy"></importC>
    <!-- 合单拆单有货 -->
    <zhipaiyouhuoCYS v-if="ZPYHflag" :rowDataList="rowDataList" :ZPYHflag.sync='ZPYHflag'></zhipaiyouhuoCYS>
     <!-- 合单拆单无货 -->
    <zhipaiwuhuoCYS v-if="ZPWHflag" :dataList="rowDataList"  :ZPWHflag.sync='ZPWHflag'></zhipaiwuhuoCYS>
    <!-- 指派 -->
    <zhipaiCYS v-if="ZPflag" :rowDataList="rowDataList"   :ZPflag.sync='ZPflag'></zhipaiCYS>
    <!-- 设置表头 -->
    <table-heads v-if="tableMark" :tableMark.sync='tableMark' :groupCode="groupCode" @refresh = 'queryMyPageField'></table-heads>
    <export-setting v-if="exportMark" :exportMark.sync='exportMark' :groupCode="groupCode"
   @exportList='exportList'></export-setting>
  </div>
</template>

<script>
import { getBtn } from '@/utils/getButton'
import { getDictionaryDetailList, findCustomerInfoList, findOrderList, getOrderAttachments,
  findAssignmentGoods, findSonSectionList, queryMyPageField } from '@/api/newTMS'
import { formatterRowEmpty, dateTimeFormat, dateFormat } from '@/utils/util'
import { exportExcel } from '@/utils/fileDownXlsx.js'
import importC from '@/components/import.vue'
import zhipaiyouhuoCYS from '@/views/newTMS/publicFiles/orderManage/zhipaiyouhuoCYS.vue'
import zhipaiwuhuoCYS from '@/views/newTMS/publicFiles/orderManage/zhipaiwuhuoCYS.vue'
import zhipaiCYS from '@/views/newTMS/publicFiles/orderManage/zhipaiCYS.vue'
import tableHeads from '@/views/newTMS/publicFiles/tableHeades.vue'
import exportSetting from '@/views/newTMS/publicFiles/exportSetting.vue'
export default {
  components: {
    importC, zhipaiyouhuoCYS, zhipaiwuhuoCYS, zhipaiCYS, tableHeads, exportSetting
  },
  data () {
    return {
      groupCode: 'carrierOrder',
      tableMark: false,
      exportMark: false,
      tabHeadList: [],
      formatterRowEmpty: formatterRowEmpty,
      dateTimeFormat: dateTimeFormat,
      dateFormat: dateFormat,
      h: 500,
      searchFrom: {
        pageNo: 1,
        pageSize: 50,
        orderStates: '0,1'
      },
      tableList: [],
      total: 0,
      loading: false,
      rules: {
        subcontractType: [
          { required: true, message: '请选择转包类型', trigger: 'blur' }
        ],
        causeCancellation: [
          { required: true, message: '请输入作废原因', trigger: 'blur' }
        ],
        generalCarrier: [
          { required: true, message: '请选择承运商', trigger: 'blur' }
        ],
        limitUserId: [
          { required: true, message: '请选择人员', trigger: 'blur' }
        ],
        limitOrgCode: [
          { required: true, message: '请选择业务部门', trigger: 'blur' }
        ]
      },
      btnFlg: [],
      btnIdArr: ['01N0020100', '01N0020200', '01N0020300', '01N0020400', '01N0020500',
        '01N0020600', '01N0020700', '01N0020800', '01N0020900' ],

      isDisable: false,
      customTypes: [],
      importDialog: false,
      ZPYHflag: false,
      ZPWHflag: false,
      ZPflag: false,
      goodform: {},
      SYgoodList: [], // 剩余货物信息
      SYHWflag: false,
      isZhankai: false,
      HWlist: [],
      YWLXlist: [],
      SRJJlist: [],
      rowDataList: [],
      fujianFlag: false,
      fujianList: [],
      lookImgFlag: false,
      imgUrl: '',
      rowData: {},
      tableKey: 0

    }
  },
  created () {
    this.btnFlg = getBtn(this.btnIdArr, '/qiYunOrder')
    this.getList(this.searchFrom)
    getDictionaryDetailList({ dictionaryType: 'goods_type' }).then(res => { this.HWlist = res })
    getDictionaryDetailList({ dictionaryType: 'business_type' }).then(res => { this.YWLXlist = res })
    getDictionaryDetailList({ dictionaryType: 'settlement_pricing' }).then(res => { this.SRJJlist = res })
    findCustomerInfoList({ businessType: 1 }).then(res => { this.kehuList = res })
    this.queryMyPageField()
  },

  mounted () {

  },
  methods: {
    tabSetting () {
      this.tableMark = true
    },
    // 查询我的页面表头
    queryMyPageField () {
      queryMyPageField({
        // 入参：tagCode 分组编码： 订单列表-> orderPage 运单列表-> wayPage 收支列表-> szPage
        tagCode: this.groupCode
      }).then(res => {
        this.tabHeadList = res
        this.$nextTick(() => {
          let h = this.$refs.searchBox.offsetHeight
          let pH = document.documentElement.clientHeight
          this.h = (pH - h - 98) + 'px'
        })
      }).catch(error => {
        this.$message({
          showClose: true,
          message: error.message,
          type: 'error',
          onClose () {
          }
        })
      })
    },
    // 附件
    fujianFn (row) {
      getOrderAttachments({ orderId: row.orderId }).then(res => {
        if (res.length == 0) {
          this.$alert('此订单没有附件', '系统提示')
        } else {
          this.fujianFlag = true
          this.fujianList = []
          res.forEach(item => {
            var filename = item.url.split('/').pop()
            this.fujianList.push({
              name: filename,
              url: item.fileKeyUrl
            })
          })
        }
      })
    },
    fujianClick (row) {
      if (this.isImage(row.name)) {
        this.lookImgFlag = true
        this.imgUrl = row.url
      } else {
        window.open(row.url)
      }
    },
    dayinImgFn () {
      this.$print(this.$refs.print)
    },
    isImage (filename) {
      const extension = filename.split('.').pop().toLowerCase()
      const imageExtensions = ['jpg', 'jpeg', 'png', 'gif', 'bmp', 'webp', 'svg']
      return imageExtensions.includes(extension)
    },
    // 货物剩余量
    WHSYLFn (row) {
      this.SYHWflag = true
      this.rowData = row
      findAssignmentGoods({ orderId: row.orderId }).then(res => {
        this.SYgoodList = res
      })
    },
    SYdayinFn () {
      this.$print(this.$refs.printSY)
    },
    // 拆单合单
    chaihedanFN (n) {
      let selectData = this.$refs.table.selection
      let isyouhuo = selectData[0].goodsYn
      let danwei = selectData[0].measuringUnit
      this.rowDataList = selectData
      this.rowDataList.forEach(item => {
        item.goodList = []
      })
      if (n == 1) { // 合单
        if (selectData.length < 2) {
          this.$alert('请选择两条以上的数据进行操作', '系统提示')
        } else {
          let flag1 = selectData.every(item => item.goodsYn == isyouhuo)
          let flag2 = selectData.every(item => item.measuringUnit == danwei)
          let flag3 = selectData.some(item => item.orderState == 2)
          if (!flag1) {
            this.$alert('只有都是有货或者无货的订单才能合单', '系统提示')
            return
          }
          if (!flag2) {
            this.$alert('只有货物单位相同的订单才能合单', '系统提示')
            return
          }
          if (flag3) {
            this.$alert('已处理的订单不能合单', '系统提示')
            return
          }
          if (isyouhuo == 1) {
            this.ZPYHflag = true
          } else {
            this.ZPWHflag = true
          }
        }
      } else {
        if (selectData.length != 1) {
          this.$alert('请选择一条要操作的数据', '系统提示')
        } else {
          if (selectData[0].orderState == 2) {
            this.$alert('已处理的订单不能拆单', '系统提示')
            return
          }
          if (isyouhuo == 1) {
            this.ZPYHflag = true
          } else {
            this.ZPWHflag = true
          }
        }
      }
    },
    // 指派
    zhipaiFN () {
      let selectData = this.$refs.table.selection
      this.rowDataList = selectData
      if (selectData.length != 1) {
        this.$alert('请选择一条要操作的数据', '系统提示')
        return
      }
      if (selectData[0].orderState == 2) {
        this.$alert('已处理的订单不能指派', '系统提示')
        return
      }
      this.ZPflag = true
    },
    exportList (val) {
      let form = { ...this.searchFrom }
      delete form.pageNo
      delete form.pageSize
      form.header = val
      exportExcel(
        this.global.tmsPlus + '/order/exportOrderList',
        form,
        '订单列表'
      )
      this.isDisable = true
      setTimeout(() => {
        this.isDisable = false // 点击一次时隔两秒后才能再次点击
      }, 2000)
    },
    // 导出
    exportFn () {
      this.exportMark = true
    },

    // 运单
    wayFn (row) {
      this.$router.push({ name: 'carrierWay', query: { orderNo: row.orderNo } })
    },
    // 打印
    dayinFN () {
      let selectData = this.$refs.table.selection
      if (selectData.length != 1) {
        this.$alert('请选择一条要操作的数据', '系统提示')
      } else {
        this.$router.push({ name: 'tmsOrderDayin', query: { id: selectData[0].orderBusinessId } })
      }
    },
    // 详情
    detailFn (row) {
      this.$router.push({ name: 'carrierOrderDetails', query: { id: row.orderBusinessId } })
    },
    // 查选
    searchFn () {
      if (this.searchFrom.cargoBarcode) {
        this.searchFrom.cargoBarcodes = this.searchFrom.cargoBarcode.replace(/\n/g, ',')
      } else {
        this.searchFrom.cargoBarcodes = ''
      }
      if (this.searchFrom.createTimes) {
        this.searchFrom.createTimeStart = this.searchFrom.createTimes[0]
        this.searchFrom.createTimeEnd = this.searchFrom.createTimes[1]
      } else {
        this.searchFrom.createTimeStart = ''
        this.searchFrom.createTimeEnd = ''
      }
      if (this.searchFrom.arrivalTimes) {
        this.searchFrom.arrivalTimeStart = this.searchFrom.arrivalTimes[0]
        this.searchFrom.arrivalTimeEnd = this.searchFrom.arrivalTimes[1]
      } else {
        this.searchFrom.arrivalTimeStart = ''
        this.searchFrom.arrivalTimeEnd = ''
      }
      this.getList(this.searchFrom)
    },
    // 选择数据
    selectGoods (selection) {
      this.weight = 0
      var that = this
      selection.forEach((item) => {
        // that.weight = (that.weight * 1000 + item.weight * 1000) / 1000
      })
    },
    // 点击选中
    handleRowClick (row, column, event) {
      this.$refs.table.toggleRowSelection(row)
    },
    // 获取货物列表
    getList (searchFrom) {
      findOrderList(searchFrom).then((res) => {
        this.tableList = []
        res.list.forEach(item => {
          if (item.stowageType == 2) {
            item.children = []
            item.hasChildren = true
          }
          this.tableList.push(item)
        })
        console.log(this.tableList)
        this.total = res.total
      })
    },
    load (tree, treeNode, resolve) {
      findSonSectionList({ orderId: tree.orderId, orderBusinessId: tree.orderBusinessId }).then((res) => {
        resolve(res)
      })
    },
    // 每页条数
    handleSizeChange (val) {
      this.searchFrom.pageSize = val
      this.getList(this.searchFrom)
    },
    // 当前页
    handleCurrentChange (val) {
      this.searchFrom.pageNo = val
      this.getList(this.searchFrom)
    },
    // 重置
    resetForm (formName) {
      this.searchFrom = {
        pageNo: 1,
        pageSize: 50
      }
    },
    // 导入
    THimportFn () {
      this.importDialog = true
    },
    destroy () {
      this.importDialog = false
    },
    DRsave (formData) {
      // const loading = this.$loading({
      //   lock: true,
      //   text: '正在处理...'
      // })
      // impOrder(formData).then(res => {
      //   loading.close()
      //   this.importDialog = false
      //   var that = this
      //   this.importMsg = this.$message({
      //     showClose: true,
      //     message: res,
      //     duration: 0,
      //     type: 'success',
      //     onClose () {
      //       loading.close()
      //     }
      //   })
      //   that.getList(that.searchFrom)
      // }).catch(error => {
      //   this.importMsg = this.$message({
      //     showClose: true,
      //     message: error.message,
      //     duration: 0,
      //     type: 'error',
      //     onClose () {
      //       loading.close()
      //     }
      //   })
      // })
    }
  },
  activated () {
    this.getList(this.searchFrom)
  },
  inject: ['reload'],
  beforeRouteEnter (to, from, next) {
    to.meta.keepAlive = true
    if (from.path != '/carrierOrder/details') {
      next(vm => {
        vm.reload()
      })
    } else {
      next()
    }
  },
  beforeRouteLeave (to, from, next) {
    if (to.path == '/carrierOrder/details') {
      from.meta.keepAlive = true
    } else {
      from.meta.keepAlive = false
    }
    next()
  }
}
</script>

<style scoped lang='less'>
.searchBtnBox{
  margin: 10px 0;
}
.inpBox .el-date-editor{
  width: 420px!important;
}
/deep/.el-form{
  width: 100%;
}
.box1 span {
  margin-left: 10px;
  font-size: 12px;
}
.addressBox .title{
  margin-left: 0;
}
.addressBox{
  margin-top:16px;
  margin-bottom: -15px;
}
.red{
color:#F56C6C ;
}
.green{
color:#01884d ;
}
.box{
  width: 100%;
   display: grid;
   grid-template-columns: repeat(auto-fill, 270px);
   grid-auto-flow: row dense;
   /deep/.el-textarea__inner{
    width: 150px;
    height: 68px;
   }
   .item1{
      grid-row-start: span 2;
    }
   .item2{
      grid-column-start: span 2;
      width: 540px;
   }
}
.box3{
  display: flex;
  flex-wrap:wrap;
  .box31{
    min-width: 300px;
  }
  p{
    margin-right: 20px;
    margin-top: 0;
  }
}
.box1{
  text-align: right;
  padding-right: 60px;
  /deep/ .icon{
    font-size: 24px;
    color:#0c46a2 ;
  }
}
.fujianBox{
  display: flex;
  flex-direction: column;
  /deep/.el-button--text{
    text-align: left;
    margin-left: 0;
    margin-bottom: 10px;
  }
}
.dayinBox{
  padding: 10px;
}
.sytable {
  border-collapse: collapse;
}
.sytable,
.sytable th,
.sytable td {
  border: 1px solid #666;
}
.sytable {
  width: 100%;
  margin: 0 auto;
  margin-bottom: 10px;
  td {
    text-align: center;
    height: 30px;
  }
  .td1{
    width: 120px;
  }
  .td3{
    width:30%;
  }
  .td2{
    width:50%;
  }
}
.table_title p{
  text-align: center;
  font-size: 22px;
}
</style>
